/** Convert tracked minutes to billable Viertelstunden (standard: 15 min per Viertel). */
export function minutesToViertel(minutes: number | null | undefined): number | null {
  if (minutes == null || minutes <= 0) {
    return null;
  }
  return Math.ceil(minutes / 15);
}

/** Format a Viertel count for display, or '-' when unset. */
export function formatViertel(value: number | null | undefined): string {
  if (value == null) {
    return '-';
  }
  return String(value);
}
